var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'form-group': _vm.withLabel,
        'has-error': _vm.error,
    }},[_vm._t("label",[_c('label',{staticClass:"control-label",attrs:{"for":_vm.name},domProps:{"textContent":_vm._s(_vm.label)}})],{"currencyPrefix":_vm.currencyPrefix}),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"id":_vm.inputId,"name":_vm.name},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},'money',_vm.money,false)),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"help-block",domProps:{"textContent":_vm._s(_vm.error)}}):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08156aa8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Utility/Forms/InputFields/MoneyInput.vue
// module id = 653
// module chunks = 0 1